export default __webpack_public_path__ + "static/media/15.cc2d6bf3.png";